//
import { RFormFields } from '@/components/reusable_components/next'
import SlCustomer from '@/models/Sale/SlCustomer'

// sl_customer_id, dte_type, dte_number, type, alias, g_state_id, flag_pending_send_dte, accounting_date
export default RFormFields
  .from([
    {
      name: 'recent',
      type: 'select',
      props: {
        label: 'Reciente',
        noObject: true,
        items: [
          {
            text: '5 dias',
            value: 5,
          },
          {
            text: '10 dias',
            value: 10,
          },
          {
            text: '30 dias',
            value: 30,
          },
          {
            text: '60 dias',
            value: 60,
          },
        ],
      },
    },
    {
      name: 'sl_customer_id',
      type: 'autocomplete-model',
      props: {
        label: 'Cliente',
        model: SlCustomer,
        itemText: 'business_name',
        itemValue: 'id',
        noObject: true,
      },
      trigger(ctx) {
        ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
        ctx.$forceUpdate()
      },
    },
    {
      name: 'sl_customer_branch_offices_id',
      type: 'select',
      props: {
        label: 'Sucursal',
        items: [],
        itemText: 'address',
        itemValue: 'id',
        noObject: true,
      },
    },
    {
      name: 'type',
      type: 'autocomplete',
      props: {
        label: 'Tipo Documento',
        noObject: true,
        items: [
          'Nota de Crédito', 
          'Nota de Débito', 
          'Boleta Electrónica', 
          'Factura Electrónica'
        ],
      },
    },
  ])
